import * as tslib_1 from "tslib";
import { AnimationClassNames } from '@uifabric/styling/lib/index';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { logUsage } from 'owa-analytics';
import { logMountingPerformance } from 'owa-analytics';
import DragAndDroppable from 'owa-dnd/lib/components/DragAndDroppable';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import folderStore from 'owa-folders';
import { showFavoritesContextMenu } from 'owa-mail-favorites-store/lib/actions/favoritesContextMenu';
import { getSelectedNode } from 'owa-mail-folder-forest-store';
import { DRAG_X_OFFSET, DRAG_Y_OFFSET } from 'owa-mail-folder-view';
import { getAnchorForContextMenu } from 'owa-positioning';
import strings from 'owa-strings/owa-mail-strings';
import TreeNode from 'owa-tree-node/lib/components/TreeNode';
import * as React from 'react';
import { ToggleFavoriteButton, lazyUpdateFavoritePosition, isGuid } from 'owa-favorites';
import { lazyMarkFavoritePersonaNodeAsAdded, lazyRemoveFavoritePersona, lazyHandleToggleFavoritePersonaError, } from 'owa-mail-favorites-store';
import { isFavoritingInProgress } from 'owa-mail-favorites-store';
import { datapoints as folderForestDatapoints, lazySelectPersona, } from 'owa-mail-folder-forest-actions';
var classnames = require('classnames');
var styles = require('./FavoriteNode.scss');
var PersonaNodeComputedState = /** @class */ (function () {
    function PersonaNodeComputedState(props) {
        this.props = props;
    }
    Object.defineProperty(PersonaNodeComputedState.prototype, "isSelected", {
        get: function () {
            return this.props.favoriteId === getSelectedNode().id;
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        computed
    ], PersonaNodeComputedState.prototype, "isSelected", null);
    return PersonaNodeComputedState;
}());
var FavoritePersonaNode = /** @class */ (function (_super) {
    tslib_1.__extends(FavoritePersonaNode, _super);
    function FavoritePersonaNode(props) {
        var _this = _super.call(this, props) || this;
        _this.renderDraggableFavoritePersonaNode = function (textClassNames) {
            return React.createElement("span", { className: textClassNames }, _this.props.displayName);
        };
        _this.renderUnreadCount = function () {
            var folderUnreadCount = _this.unreadCount();
            var unreadCount = folderUnreadCount === 0 ? null : folderUnreadCount;
            return (React.createElement("span", { className: styles.unreadCount },
                unreadCount,
                React.createElement("span", { className: "screenReaderOnly" }, 
                // for a treeitem, inner content that have aria-hidden=true are not hidden in IE
                // therefore we cannot hide the visual string and use a screenReaderOnly string that has the count
                strings.unreadCountScreenReaderOnlyText)));
        };
        _this.renderToggleFavorite = function () {
            return (React.createElement(ToggleFavoriteButton, { isInFavorites: true, onClick: _this.removeFavoritePersona, iconStyles: styles.favoriteButton }));
        };
        _this.removeFavoritePersona = function (evt) {
            evt.stopPropagation();
            var isInProgress = isFavoritingInProgress(_this.props.personaId) ||
                isFavoritingInProgress(_this.props.emailAddress);
            if (isInProgress) {
                // Do nothing: favoriting is in progress
                return;
            }
            lazyRemoveFavoritePersona
                .importAndExecute(_this.props.favoriteId, 'PersonaNodeFavoriteButton')
                .catch(function () { return lazyHandleToggleFavoritePersonaError.importAndExecute(true); });
        };
        _this.onPersonaSelected = function (evt, personaId) {
            evt.stopPropagation();
            var _a = folderForestDatapoints.personaClicked.datapoint, eventName = _a.name, customData = _a.customData;
            var idToLog = isGuid(_this.props.favoriteId) ? _this.props.favoriteId : '';
            logUsage(eventName, customData(idToLog, _this.unreadCount()));
            lazySelectPersona.importAndExecute(_this.props.favoriteId);
        };
        _this.onContextMenu = function (evt) {
            evt.stopPropagation();
            evt.preventDefault();
            if (_this.props.isSearchFolderPopulated &&
                folderStore.folderTable.has(_this.props.searchFolderId)) {
                showFavoritesContextMenu(_this.props.favoriteId, 1 /* Persona */, folderStore.folderTable.get(_this.props.searchFolderId), getAnchorForContextMenu(evt));
            }
        };
        // VSO 23480 - [FavoritesDND]Refactor the common DND code into a base component
        _this.canDrop = function (dragData) {
            if (!_this.props.searchFolderId) {
                return false;
            }
            return dragData.itemType === DraggableItemTypes.FavoriteNode;
        };
        _this.onDrop = function (dragData) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var draggedFavorite, dropTargetId, dragTargetId, updateFavoritePosition;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.canDrop(dragData)) {
                            return [2 /*return*/];
                        }
                        draggedFavorite = dragData;
                        dropTargetId = this.props.favoriteId;
                        dragTargetId = draggedFavorite.favoriteId;
                        return [4 /*yield*/, lazyUpdateFavoritePosition.import()];
                    case 1:
                        updateFavoritePosition = _a.sent();
                        updateFavoritePosition(dragTargetId /* idToUpdate */, dropTargetId /* destinationFolderId */, draggedFavorite.favoriteType);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.getDragData = function () {
            var folderNodeDragData = {
                itemType: DraggableItemTypes.FavoriteNode,
                favoriteId: _this.props.favoriteId,
                favoriteType: 1 /* Persona */,
                displayName: _this.props.displayName,
            };
            return folderNodeDragData;
        };
        _this.getDragPreview = function (folderNodeDragData) {
            var elem = document.createElement('div');
            elem.className = styles.dragPreview;
            elem.innerText = folderNodeDragData.displayName;
            return elem;
        };
        _this.computedState = new PersonaNodeComputedState(_this.props);
        return _this;
    }
    FavoritePersonaNode.prototype.componentDidMount = function () {
        this.markNodeAsAdded();
    };
    FavoritePersonaNode.prototype.render = function () {
        var _this = this;
        return (React.createElement(DragAndDroppable, { getDragData: this.getDragData, getDragPreview: this.getDragPreview, xOffset: DRAG_X_OFFSET, yOffset: DRAG_Y_OFFSET, dropViewState: this.props.dropViewState, onDrop: this.onDrop, canDrop: this.canDrop },
            React.createElement("div", { className: this.props.isJustAdded
                    ? classnames(AnimationClassNames.slideDownIn20, styles.addedNode)
                    : '' },
                React.createElement(TreeNode, { customIcon: "Contact" /* Contact */, displayName: this.props.displayName, key: this.props.favoriteId, isDroppedOver: this.props.dropViewState.isDragOver, isRootNode: false, isSelected: this.computedState.isSelected, onClick: function (evt) {
                        return _this.onPersonaSelected(evt, _this.props.favoriteId);
                    }, onContextMenu: this.onContextMenu, renderCustomTreeNodeDisplay: this.renderDraggableFavoritePersonaNode, renderRightCharm: this.renderUnreadCount, renderRightCharmHover: this.renderToggleFavorite, showAsHoverOnDroppedOver: false }))));
    };
    FavoritePersonaNode.prototype.unreadCount = function () {
        if (this.props.isSearchFolderPopulated &&
            folderStore.folderTable.has(this.props.searchFolderId)) {
            var folder = folderStore.folderTable.get(this.props.searchFolderId);
            return folder.UnreadCount;
        }
        return 0;
    };
    FavoritePersonaNode.prototype.markNodeAsAdded = function () {
        var _this = this;
        if (this.props.isJustAdded) {
            setTimeout(function () {
                lazyMarkFavoritePersonaNodeAsAdded.importAndExecute(_this.props.favoriteId);
            }, 666 /* animation duration */);
        }
    };
    FavoritePersonaNode = tslib_1.__decorate([
        observer,
        logMountingPerformance('FavoritePersonaNode')
    ], FavoritePersonaNode);
    return FavoritePersonaNode;
}(React.Component));
export default FavoritePersonaNode;
//# sourceMappingURL=FavoritePersonaNode.js.map